export const FETCH_PROFILE_INIT = 'FETCH_PROFILE_INIT';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';


export const DELETE_ACCOUNT_INIT = 'DELETE_ACCOUNT_INIT';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAILURE = 'DELETE_ACCOUNT_FAILURE';



// WEBPACK FOOTER //
// ./src/routes/Profile/modules/types.js